var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "17", height: "21", viewBox: "0 0 17 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.81.074c.14.059.263.151.36.267l6.49 6.537a.954.954 0 0 1 .34.72v9.52c0 2.102-1.691 3.805-3.778 3.805H3.778C1.69 20.923 0 19.22 0 17.12V3.804C0 1.704 1.691 0 3.778 0h5.678a.841.841 0 0 1 .354.074zm.579 3.168v2.464c0 .526.423.951.944.951h2.448l-3.392-3.415zm-8.5.562c0-1.05.846-1.902 1.889-1.902H8.5v3.804a2.843 2.843 0 0 0 2.833 2.853h3.778v8.56c0 1.05-.846 1.902-1.889 1.902H3.778a1.896 1.896 0 0 1-1.89-1.902V3.804z", fill: "#A2A9B4" })
  );
});